/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useAppContext } from '../../context/appContext'
export default function Mouth1(props) {
  const { colorArr } = useAppContext()
  const { nodes, materials } = useGLTF('/models/Mouth1.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Mouth1.geometry}
        material={materials.Red}
        position={[0, 233.79, 120.76]}
      >
        <meshPhysicalMaterial
          color={colorArr[2]}
          reflectivity={1}
          roughness={0.8}
        />
      </mesh>
    </group>
  )
}

useGLTF.preload('/models/Mouth1.glb')
